<template>
    <loader v-if="loading" />
    <div v-else>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-text>
                        <vue-apex-charts height="400px" type="line" :options="{ ...complaintsChartOptions, title: { text: 'Samlet antal sager' }}" :series="totalSeries" />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-text>
                        <vue-apex-charts height="400px" type="line" :options="{ ...complaintsChartOptions, title: { text: 'Antal sager pr. team' }}" :series="teamSeries" />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-text>
                        <vue-apex-charts height="400px" type="line" :options="{ ...salesChartOptions, title: { text: 'Sager ift. antal salg' }}" :series="salesCountSeries" />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
	components: {
		VueApexCharts
    },
    data () {
        return {
            loading: true,
            totalSeries: [],
            salesCountSeries: [],
            teamSeries: {},
            teams: [],
            complaintsChartOptions: {
                chart: {
                    toolbar: {
                        show: false
                    },
                    animations: {
                        enabled: false
                    }
                },
                grid: {
                    xaxis: {
                        lines: {
                            show: true
                        }
                    }
                },
                yaxis: [
                    {
                        labels: {
                            formatter: this.$options.filters.separator
                        }
                    }
                ],
                colors: ['#546E7A', '#F5B041', '#FF0000', '#00CCCC', '#FF33FC', '#E91E63', '#FF9800'],
                dataLabels: {
                    enabled: true,
                    formatter: this.$options.filters.separator
                }
            },
            salesChartOptions: {
                stroke: {
                    width: [0, 0, 2]
                },
                chart: {
                    stacked: true,
                    toolbar: {
                        show: false
                    },
                    animations: {
                        enabled: false
                    }
                },
                yaxis: [
                    {
                        labels: {
                            formatter: this.$options.filters.separator
                        },
                        seriesName: 'Salg med sager'
                    },
                    {
                        show: false,
                        labels: {
                            formatter: this.$options.filters.separator
                        },
                        seriesName: 'Salg med sager'
                    },
                    {
                        opposite: true,
                        labels: {
                            formatter: this.$options.filters.percentageDecimal,
                            max: 1
                        }
                    }
                ],
                colors: ['#FF0000', '#009900', '#FF00FF'],
                dataLabels: {
                    enabled: true,
                    enabledOnSeries: [2],
                    formatter: val => val > 0 ? this.$options.filters.percentageDecimal(val) : ''
                }
            }
        }
    },
    computed: {
        year () {
            return this.$store.state.quality.year
        },
        department () {
            return this.$store.getters['quality/department']
        }
    },
    methods: {
        async getData () {
            this.loading = true
            const response = await this.$http().get('/quality/development/complaints', {
                params: {
                    year: this.year,
                    department: this.department
                }
            })
            this.totalSeries = response.data.totalSeries
            this.teamSeries = response.data.teamSeries
            this.salesCountSeries = response.data.salesCountSeries
            this.teams = response.data.teams
            this.loading = false
        }
    },
    watch: {
        year: function () {
            this.getData()
        },
        department: function () {
            this.getData()
        }
    },
    created () {
        this.getData()
    }
}
</script>